<template>
  <div class="client opportunity overview-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog v-model="editing" max-width="900px" width="66vw">
      <v-card>
        <v-card-title class="title">Edit Opportunity Overview</v-card-title>

        <v-divider />

        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-text-field
              label="Opportunity Name"
              v-model="modifiedOpportunity.name"
              required
              :rules="modifiedOpportunity.remuneration.disclosed ? rules.name : []"
              :error-messages="errors.name || []"
              :color="themes.client.light.input"
            />
            <v-autocomplete
              label="Currency"
              :items="currencies"
              v-model="modifiedOpportunity.remuneration.currency"
              :rules="modifiedOpportunity.remuneration.disclosed ? rules.currency : []"
              required
              :error-messages="errors.currency || []"
              :color="themes.client.light.input"
              :menu-props="{ offsetY: true }"
            />
            <v-text-field
              label="Amount"
              v-model="modifiedOpportunity.remuneration.amount"
              type="number"
              :rules="modifiedOpportunity.remuneration.disclosed ? rules.amount : []"
              required
              :error-messages="errors.amount || []"
              :color="themes.client.light.input"
            />
            <v-select
              label="Interval"
              v-model="modifiedOpportunity.remuneration.frequency"
              :items="frequencies"
              :rules="rules.frequency"
              required
              :error-messages="errors.currency || []"
              :color="themes.client.light.input"
              :menu-props="{ offsetY: true }"
            />
            <v-layout row wrap align-center>
              <v-flex xs12 md6 class="px-3">
                <v-btn block
                  @click="modifiedOpportunity.remuneration.disclosed = true"
                  :outline="!modifiedOpportunity.remuneration.disclosed"
                  :color="themes.client.light.primaryActionButton"
                >
                  Disclose remuneration
                </v-btn>
              </v-flex>

              <v-flex xs12 md6 class="px-3">
                <v-btn block
                  @click="modifiedOpportunity.remuneration.disclosed = false"
                  :outline="modifiedOpportunity.remuneration.disclosed"
                  :color="themes.client.light.primaryActionButton"
                >
                  Don't disclose remuneration
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>

          <div class="text-xs-left pa-3">
            <v-icon left>mdi-information</v-icon>Edit locations and positions in the Locations and
            Dates section
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="cancel" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn @click="submit" :color="themes.client.light.primaryActionButton"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Data
import currencyList from '@/data/currencies'

// Vue Component
export default {
  props: {
    opportunity: Object,
    organization: Object,
    canEdit: Boolean,
  },

  data() {
    return {
      modifiedOpportunity: Object.assign({}, this.opportunity),
      editing: false,
      valid: true,
      rules: {
        name: [v => !!v || 'must be specified'],
        currency: [v => !!v || 'must be specified'],
        amount: [v => !!v || (!isNaN(parseFloat(v)) && isFinite(v)) || 'must be a number'],
        frequency: [v => !!v || 'must be specified'],
        disclosed: [],
      },
      errors: {},
      loading: false,

      // Data
      frequencies: [
        { text: 'Yearly', value: 1 },
        { text: 'Monthly', value: 12 },
        { text: 'Weekly', value: 52 },
      ],
    }
  },

  computed: {
    remunerationComplete() {
      return (
        this.opportunity.remuneration.amount &&
        this.opportunity.remuneration.currency &&
        this.opportunity.remuneration.frequency
      )
    },
    currencies() {
      return Object.values(currencyList)
        .map(c => {
          return {
            text: c.name,
            value: c.iso.code,
          }
        })
        .sort((a, b) => {
          if (a.text.toUpperCase() < b.text.toUpperCase()) return -1
          if (a.text.toUpperCase() > b.text.toUpperCase()) return 1
          return 0
        })
    },
    frequency() {
      return this.frequencies.find(f => {
        return f.value === this.opportunity.remuneration.frequency
      }).text
    },
  },

  watch: {
    editing() {
      this.modifiedOpportunity = JSON.parse(JSON.stringify(this.opportunity))
    },
  },

  methods: {
    frequencyDescriptor(frequency) {
      return {
        1: 'yearly',
        12: 'monthly',
        52: 'weekly',
      }[frequency]
    },

    cancel() {
      this.modifiedOpportunity = Object.assign({}, this.opportunity)
      this.editing = false
      this.errors = {}
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch('client/opportunities/update', this.modifiedOpportunity)
          .then(errors => {
            if (errors) {
              this.errors = errors
              this.$store.dispatch('snackbarError', 'Save failed')
            } else {
              this.$store.dispatch('snackbarSuccess', 'Save successful')
              this.editing = false
            }
          })
          .finally(() => (this.loading = false))
      }
    },
  },
}
</script>
